import { COURSE_NAV_ID, EVENT_NAV_ID } from '@/config/elocusConfig'

export const navNames = {
  // Cursussen
  [COURSE_NAV_ID]: {
    en: 'Courses overview ',
    nl: 'Cursus overzicht ',
  },
  [EVENT_NAV_ID]: {
    en: 'Events overview ',
    nl: 'Evenementen overzicht ',
  },
}
